<script>
import bookingFlowImg from '../../images/booking-step.png'
import Multiselect from "vue-multiselect";

import axiosApi from '../shared/api.js'
import axios from "axios";
import CountrySelect from './CountrySelect.vue'
import DiscoverSearch from './DiscoverSearch.vue'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/themes/material_orange.css';

import closeImage from '../../images/close-orange.svg'
import flashImage from '../../images/icon-energy.svg'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import NewBooking from '../booking/NewBooking.vue';

export default {
  props: [
    "query",
    "showBookingButton",
    "onlyHeader",
    "sidebarShow",
    "discoverFilterItems",
    "discoverFilterIcons",
    "artTypeFilter",
    "genreFilter",
    "eventTypeFilter",
    "cityNameFilter",
    "specialityFilter",
    "selectedCountry",
    "searchLocation",
  ],
  components: {
    Multiselect,
    flatPickr,
    CountrySelect,
    DiscoverSearch,
    NewBooking
  },
  data() {
    return {
      url: '',
      dates: [],
      searchOptions: [],
      genresFilterType: '',
      seo_country: '',
      current_city: '',
      bookingFlowImg: bookingFlowImg,
      initialLoad: false,
      closeImage: closeImage,
      flashImage: flashImage,
      wasInteractedByUser: false,
      cities: [],
      eventTypes: [],
      artTypes: [],
      specialities: [],
      genres: [],
      perfomanceTypes: [],
      showValue: true,
      languages: [],
      citySelectorValue: [],
      eventTypeSelectorValue: [],
      artTypeSelectorValue: [],
      specialitySelectorValue: [],
      genresSelectorValue: [],
      perfomanceTypesSelectorValue: [],
      languageSelectorValue: [],
      discoverPageSeo: [],
      newBookingModalVueInstance: '',
      bookingModalEl: '',
      seo_location_country: '',
      errors: null,
      newQuery: {
        by_city: null,
        by_art_type: null,
        by_speciality: null,
        by_genre: null,
        by_event_type: null,
        by_performance_type: null,
        by_max_budget: null,
        by_language: null
      },
      isArtist: true,
      dateConfig: {
        mode: 'multiple',
        wrap: true,
        enable: [
          function(date) {
            return date >= new Date().setHours(0,0,0,0);
          }
        ]
      }
    };
  },
  mounted() {
    const token = localStorage.getItem('token', '')
    this.bookingModalEl = document.getElementById("instant-quote-modal")
    if (token === null || token === '') {
      axios.get(`${window.location.origin}/api_tokens/new.json`)
      .then(response => {
        localStorage.setItem('token', response.data.jwt)
      })
    }
    this.seo_location_country = localStorage.getItem('country_name')
    axiosApi.get('/users/profile', { headers: {
          Authorization: localStorage.getItem('token', ''),
        }
      }).then(response => {
      this.isArtist = response.data.artist
      this.current_city = response.data.current_city
      this.seo_country = response.data.seo_current_country
    })
    .catch(error => {
      this.isArtist = false
    })
    const bookingModalCloseBtn = document.getElementById("instant-quote-close-btn")

    bookingModalCloseBtn.addEventListener('click', () => {
      this.updateUrl()
      if (this.bookingModalEl) {
        if (this.sidebarShow) this.showSidebar()
        this.bookingModalEl.__x.$data.isBookingDialogOpen = false
      }
      let body = document.getElementsByTagName("body")[0]
      body.style.overflow = "unset"
      this.newBookingModalVueInstance.$destroy()
      this.newBookingModalVueInstance.$el.remove()

      document.getElementById('instant-quote-modal-body').appendChild(
        Object.assign(
          document.createElement('div'),
          { id : 'vue-new-booking' }
        )
      )
    })
  },
  created() {
    this.initData(this.query);
  },
  updated() {
    if(this.discoverPageSeo && this.discoverPageSeo.length > 0) {
      let descriptionBackground = document.querySelector(".discover-page-seo-description")
      let arrow = document.querySelector(".arrow-down-black")
      if (descriptionBackground.scrollHeight<=48) {
        arrow.style.display = "none"
      }
      else if (arrow.style.display=="none") {
        arrow.style.display = "unset"
      }
    }
  },
  watch: {
    artTypeSelectorValue() {
      this.clearOptions();
      this.getArtTypeRelations(this.artTypeSelectorValue);
      this.updateMetas();
      this.$emit('breadcrumbsUpdate', this.makeBreadCrumbsData());
    },
    sidebarShow(ss) {
      if (ss) {
        document.querySelector("body").style = "overflow: hidden;";
      } else {
        document.querySelector("body").style = null;
      }
    },
    citySelectorValue() {
      this.showValue = false
      if (this.initialLoad) {
        this.citySelectorValue.length > 0 ? localStorage.setItem('show_city', true) : ''
        this.updateContentBlock()
      }
      this.updateMetas();
      this.$emit('breadcrumbsUpdate', this.makeBreadCrumbsData());
    },
    specialitySelectorValue() {
      if (this.initialLoad) {
        this.showValue = false
        this.updateContentBlock()
      }
      this.initialLoad = true
      this.updateMetas();
      this.$emit('breadcrumbsUpdate', this.makeBreadCrumbsData());
    },
    genresSelectorValue() {
      this.updateMetas();
      this.$emit('breadcrumbsUpdate', this.makeBreadCrumbsData());
    },
  },
  methods: {
    updateMetas() {
      const metaKeywordsId = 'discover-meta-keywords';
      let metaElement = document.getElementById(metaKeywordsId);
      if (!metaElement) {
        metaElement =  document.createElement('meta');
        metaElement.name = 'keywords';
        metaElement.id = metaKeywordsId;
        document.head.appendChild(metaElement);
      }
      const keywords = [];
      const artTypes = [];
      const cities = [];
      if (this.artTypeSelectorValue?.length > 0) {
        this.artTypeSelectorValue?.forEach(i => {
          keywords.push(i.name.toLowerCase());
          artTypes.push(i.name);
        });
      }
      if (this.specialitySelectorValue?.length > 0) {
        this.specialitySelectorValue?.forEach(i => keywords.push(i.name.toLowerCase()))
      }
      keywords.push('book', 'rent');
      keywords.push();
      keywords.push(localStorage.getItem('country_name').toLowerCase());
      keywords.push('soulartists', 'music','events', 'party', 'wedding', 'birthday');
      metaElement.content = keywords.join(', ');

      const metaDescription = document.querySelector('meta[name="description"]');
      const metaTwitterDescription = document.querySelector('meta[name="twitter:description"]');
      const metaOGDescription = document.querySelector('meta[property="og:description"]');
      if (this.citySelectorValue?.length > 0) {
        this.citySelectorValue.forEach(i => cities.push(i.name))
      }
      const artistsText = artTypes.length > 0 ? ' ' + artTypes.join(', ') : ' Artists';
      const description = `Find and hire the best${artistsText}${cities.length > 0 ? ' in '+ cities.join(', ') : ''} on Soulartists. With Soulartists it’s simple to post your event and we’ll quickly match you with great${artistsText} in ${localStorage.getItem('country_name')} for your event.`;
      metaDescription.content = description;
      metaOGDescription.content = description;
      metaTwitterDescription.content = description;
    },
    makeBreadCrumbsData() {
      return {
        selectedCountry: this.selectedCountry,
        countrySlug: localStorage.getItem('short_form', ''),
        cityNameFilter: this.citySelectorValue?.map(city => ({
          ...city,
          slugName: this.generateShortForm(city.name)?.toLowerCase()
        })),
        artTypeFilter: this.artTypeSelectorValue,
        specialityFilter: this.specialitySelectorValue,
        genreFilter: this.genresSelectorValue,
      }
    },
    updatedUrl(url) {
      const currentPath = window.location.pathname;
      const match = currentPath.match(/\/discover\/([^\/]+)/);
      const currentLocation = match ? match[1] : "ae";
      return url.replace(/\/discover\/([^\/]+)/, `/discover/${currentLocation}`);
    },
    filtersUpdated(event) {
      if (!this.sidebarShow) this.updateQuery();
    },
    updateContentBlock() {
      setTimeout( () => {
        axiosApi.get('/artists/discover_page_seos').then(response => {
          var urlArtTypeExist = false
          var urlSpecialityExist = false
          var artTypeWithoutSpeciality = false 
          response.data.filter(discoverPageSeo => {
              urlSpecialityExist = urlSpecialityExist ? true : this.specialitySelectorValue.some((speciality)=> { return discoverPageSeo.specialities.length > 0 ? speciality.slug==discoverPageSeo.specialities[0].slug : false })
              artTypeWithoutSpeciality = artTypeWithoutSpeciality ? true : this.artTypeSelectorValue.some((artType)=> { return artType.slug==discoverPageSeo.art_type_slug && discoverPageSeo.specialities.length == 0 })
          })
          // For Two Section
          let container = document.getElementsByClassName("container")[5].children[0]
          let questions = document.getElementsByClassName("questions")
          let answers1 = document.getElementsByClassName("answer")
          let answers2 = document.getElementsByClassName("mobile-answer")
          let artTypeOrSpeciality = this.specialitySelectorValue.length > 0 ? this.specialitySelectorValue[0].name : this.artTypeSelectorValue.length > 0 ? this.artTypeSelectorValue[0].name : "artist"
          const prefix = artTypeOrSpeciality=='artist' ? 'an' : 'a'
          let answer1 = `When booking ${prefix} ${artTypeOrSpeciality} in ${this.citySelectorValue.length > 0 ? this.citySelectorValue[0].name : this.seo_location_country }, its crucial to know what is included in the price. One you submit your inquiry with your event details you will receive quotes directly from the ${artTypeOrSpeciality}. You will be able to message the artist directly before confirming the booking. Each artist has a different price depending on the experience they provide, but you can always mention your budget to get accurate quotes.`
          let answer2 = `Booking ${prefix} ${artTypeOrSpeciality} in ${this.citySelectorValue.length > 0 ? this.citySelectorValue[0].name : this.seo_location_country } with Soul Artists is simple. Just click on the get instant quotes button or search for ${artTypeOrSpeciality} in your area, check their availability or send them a message to get quotes. You can book and pay directly through Soul Artists. If you don't find a suitable ${artTypeOrSpeciality}, We can help you find the perfect match for your needs in ${this.citySelectorValue.length > 0 ? this.citySelectorValue[0].name : this.seo_location_country }.`
          let answer3 = `Soul Artists provides a money-back guarantee on all bookings made through our platform. If the ${artTypeOrSpeciality} did not show up to your event or has cancelled for any reason, we'll either find you a replacement ${artTypeOrSpeciality} or refund your money`
          container.innerText = `Booking ${prefix} ${artTypeOrSpeciality} in ${this.citySelectorValue.length > 0 ? this.citySelectorValue[0].name : this.seo_location_country }`
          questions[0].children[1].innerText = `What's the average price of ${prefix} ${artTypeOrSpeciality} in ${this.citySelectorValue.length > 0 ? this.citySelectorValue[0].name : this.seo_location_country }?`
          questions[1].children[1].innerText = `How do I book ${prefix} ${artTypeOrSpeciality} in ${this.citySelectorValue.length > 0 ? this.citySelectorValue[0].name : this.seo_location_country }?`
          questions[2].children[1].innerText = `What's is Soul Artists money-back guarantee when booking ${prefix} ${artTypeOrSpeciality} in ${this.citySelectorValue.length > 0 ? this.citySelectorValue[0].name : this.seo_location_country }?`
          answers1[0].innerText = answer1
          answers1[1].innerText = answer2
          answers1[2].innerText = answer3
          answers2[0].innerText = answer1
          answers2[1].innerText = answer2
          answers2[2].innerText = answer3

          this.discoverPageSeo = response.data.some(discoverPageSeo => {
            var specialityExist = this.specialitySelectorValue.some((speciality)=> { return discoverPageSeo.specialities.length > 0 ? speciality.slug==discoverPageSeo.specialities[0].slug : false })
            var artTypeExist = this.artTypeSelectorValue.some((artType)=> { return artType.slug==discoverPageSeo.art_type_slug })
            let showArtType = artTypeExist && artTypeWithoutSpeciality && !urlSpecialityExist && discoverPageSeo.specialities.length == 0 ? artTypeWithoutSpeciality : artTypeExist && !urlSpecialityExist && !artTypeWithoutSpeciality ? true : false
            if (specialityExist && urlSpecialityExist) {
              let contentDisplay = document.getElementsByClassName("content-display");
              contentDisplay[0].style.display="block"
              let seoHeader = document.getElementsByClassName("seo-header");
              let description = document.getElementsByClassName("discover-page-seo-description");
              seoHeader[0].innerText = `${discoverPageSeo.header} in`
              seoHeader[1].innerText = this.citySelectorValue.length > 0 ? this.citySelectorValue[0].name : this.seo_location_country
              let cities = this.cities.slice().sort((a, b) => a.id - b.id)
              let city = this.citySelectorValue.length > 0 ? this.citySelectorValue[0].name : cities[0].name
              let city2Name = cities[1].name == city ? cities[0].name : cities[1].name
              description[0].innerText = discoverPageSeo.description.replace(/{{city}}/g, city)
              .replace(/{{city2}}/g, city2Name)
              .replace("{{country}}", this.seo_location_country);

              return true
            } else if((showArtType && !specialityExist)) {
              let contentDisplay = document.getElementsByClassName("content-display");
              contentDisplay[0].style.display="block"
              let seoHeader = document.getElementsByClassName("seo-header");
              let description = document.getElementsByClassName("discover-page-seo-description");
              seoHeader[0].innerText = `${discoverPageSeo.art_type_name} in`
              seoHeader[1].innerText = this.citySelectorValue.length > 0 ? this.citySelectorValue[0].name : this.seo_location_country
              let cities = this.cities.slice().sort((a, b) => a.id - b.id)
              let city = this.citySelectorValue.length > 0 ? this.citySelectorValue[0].name : cities[0].name
              let city2Name = cities[1].name == city ? cities[0].name : cities[1].name
              description[0].innerText = discoverPageSeo.description.replace(/{{city}}/g, city)
              .replace(/{{city2}}/g, city2Name)
              .replace(/{{country}}/g, this.seo_location_country);
              return true;
            } else {
              let contentDisplay = document.getElementsByClassName("content-display")
              if (contentDisplay.length > 0) {
                contentDisplay[0].style.display="none"
              }
            }
          });
        })
      }, 800)
    },
    showSidebar() {
      if (document.querySelector(".main-container").clientWidth < 1024) {
        this.$emit('update:sidebarShow', !this.sidebarShow);
      }
    },
    generateShortForm(name) {
      const lowerName = name.toLowerCase();
      const specialCases = ['los angeles', 'new york', 'las vegas'];

      if (specialCases.includes(lowerName)) {
        return lowerName.replace(/\s+/g, '-');
      }
      return name.replace(/\s+/g, '')
    },
    booking_protection_url() {
      return `${window.location.origin}/clients`
    },
    filterArrayByIds(idsArray, dataArray) {
      if (idsArray) return dataArray.filter(i => idsArray.includes(i.slug));
      return []
    },
    updateQuery() {
      let by_art_type =
      this.newQuery = {
        by_city: this.citySelectorValue.map(i => i.slug),
        by_art_type: this.artTypeSelectorValue.map(i => i.slug),
        by_speciality: this.specialitySelectorValue.map(i => i.slug),
        by_genre: this.genresSelectorValue.map(i => i.slug),
        by_event_type: this.eventTypeSelectorValue.map(i => i.slug),
        ...(localStorage.getItem('language_slug') ? 
          { by_language: [localStorage.getItem('language_slug')] } : 
          { by_language: this.languageSelectorValue.map(i => i.slug) }
        ),
        by_performance_type: this.perfomanceTypesSelectorValue.map(i => i.slug),
      };
      this.seo_location_country = localStorage.getItem('country_name')
      this.updateUrl()
      this.updateMetas();
      this.$emit("queryChanged", this.newQuery);
      this.$emit("breadcrumbsUpdate", this.makeBreadCrumbsData());
      if (this.artTypeSelectorValue.length > 0) {
        this.$emit("arTypeName", this.artTypeSelectorValue[0].name);
      }
      else {
        this.$emit("arTypeName", "DJ");
      }
    },
    updateUrl() {

      let url = window.location.origin + window.location.pathname
      let show_city = localStorage.getItem('show_city', '')
      let country_name = `/${localStorage.getItem('short_form', '')}`
      let city = this['citySelectorValue'].length > 0 && show_city == 'true' ? `/${this['citySelectorValue'].map(city => this.generateShortForm(city.name)).join(',').toLowerCase()}` : this.cityNameFilter.length > 0 && show_city == 'true' && this.showValue ? `/${this.generateShortForm(this.cityNameFilter[0]).toLowerCase()}` : ''
      let location = city ? city : country_name
      let artType = this['artTypeSelectorValue'].length >  0 ? `${this['artTypeSelectorValue'].map(artType => artType.slug).join(',').toLowerCase()}` : this.artTypeFilter.length > 0 && this.showValue ? `${this.artTypeFilter.toLowerCase()}` : ''
      let eventType = this['eventTypeSelectorValue'].length >  0 ? `${this['eventTypeSelectorValue'].map(eventType => eventType.slug).join(',').toLowerCase()}` : this.eventTypeFilter.length > 0 && this.showValue ? `/${this.eventTypeFilter.toLowerCase()}` : ''
      let eventTypeFilter = artType && eventType ? `/${eventType},` : eventType ? `/${eventType}` : artType ? '/' : ''
      let speciality = this['specialitySelectorValue'].length > 0 ? `/${this['specialitySelectorValue'].map(speciality => speciality.slug).join(',').toLowerCase()}` : this.specialityFilter.length > 0 && this.showValue ? `/${this.specialityFilter.toLowerCase()}` : ''
      let genre = this['genresSelectorValue'].length >  0 ? `/${this['genresSelectorValue'].map(genre => genre.slug).join(',').toLowerCase()}` : this.genreFilter.length > 0 && this.showValue ? `/${this.genreFilter.toLowerCase()}` : ''
      let newUrl = ( artType ? `/discover${location}${eventTypeFilter}${artType}${speciality}${genre}` : `/discover${location}${eventTypeFilter}`)
      let constructedUrl = new URL(newUrl, url);
      localStorage.setItem('show_city', true)
      localStorage.setItem('no_city', true)
      history.replaceState({turbolinks: true}, '', constructedUrl)
      if (this.sidebarShow) this.showSidebar()
    },
    updateSearchParams(params_key, value_key, searchParams) {
      let value
      let cityIds
      if (params_key=='city') {
        cityIds = this[value_key].map(i => i.slug)
        value = this[value_key].map(i => i.name.replace(/\s+/g, '-'))
      } else {
        value = params_key=="language" && localStorage.getItem('language_slug')? [`${localStorage.getItem('language_slug')}`] : this[value_key].map(i => i.slug)
      }
      let show_city = localStorage.getItem('show_city', '')
      if (value.length > 0 && show_city == 'true') {
        if (params_key=='city') {
          localStorage.setItem(`discover_${params_key}`, cityIds)
          let country_name =localStorage.getItem('country_name', '')
          if (country_name) {
            searchParams.push(`by_${params_key}=${value}&by_country=${localStorage.getItem('country_name').replace(/\s+/g, '-')}`)
          }
        } else {
          localStorage.setItem(`discover_${params_key}`, value)
          searchParams.push(`by_${params_key}=${value}`)
        }
      } else {
        localStorage.removeItem(`discover_${params_key}`)
      }
      return searchParams
    },
    initData(query) {
      if (query) {
        let location = localStorage.getItem('location_country')
        this.seo_location_country = localStorage.getItem('country_name')
        axiosApi.get('/cities', {
          params: {
            country_code: location,
          }
        })
        .then(response => {
          this.cities = response.data.filter((city, index, self) =>
            index === self.findIndex(c => c.name.toLowerCase() === city.name.toLowerCase())
          )
          let filterCity = []
          if (query.by_city.length > 0 && typeof(query.by_city[0]) != "number") {
            for(let i = 0; i < this.cities.length; i++) {
              query.by_city.map((city)=> {
                if(this.cities[i].id==Number(city)) {
                  filterCity.push(this.cities[i].slug)
                }
              })
            }
            this.citySelectorValue = this.filterArrayByIds(
              filterCity,
              response.data
            )
          } else {
            this.citySelectorValue = this.filterArrayByIds(
              query.by_city,
              response.data
            )
          }
        })
        axiosApi.get('/event_types').then(response => {
          this.eventTypes = response.data
          this.eventTypeSelectorValue = this.filterArrayByIds(
            query.by_event_type,
            response.data
          )
        })
        axiosApi.get('/art_types').then(response => {
          this.artTypes = response.data
          this.artTypeSelectorValue = this.filterArrayByIds(
            query.by_art_type,
            response.data
          )
          this.setInitialArtTypeRelations(this.artTypeSelectorValue, query);
        })
        axiosApi.get('/languages').then(response => {
          this.languages = response.data
          if (localStorage.getItem('language_slug')) {
            this.languageSelectorValue = this.filterArrayByIds(
              localStorage.getItem('language_slug'),
              response.data
            ) 
          }else {
            this.languageSelectorValue = this.filterArrayByIds(
              query.by_language,
              response.data
            )
          }

          localStorage.removeItem('language_slug')
        })
      }
    },
    setInitialArtTypeRelations(artTypesArray, query) {
      if (artTypesArray.length) {
        const artTypesIds = artTypesArray.map(artType => artType.slug);
          axiosApi.get('/art_types/relations', { params:
            { art_type_ids: artTypesIds }
          }).then(response => {
              const newSpecialities = this.specialities;
              this.specialities = [...newSpecialities, ...response.data.specialities];

              this.specialitySelectorValue = this.filterArrayByIds(
                query.by_speciality,
                response.data.specialities
              );

              const newGenres = this.genres;
              this.genres = [...newGenres, ...response.data.genres];

              this.genresSelectorValue = this.filterArrayByIds(
                query.by_genre,
                response.data.genres
              );

              const newPerfomanceTypes = this.perfomanceTypes;
              this.perfomanceTypes = [
                ...newPerfomanceTypes,
                ...response.data.performance_types
              ];

              this.perfomanceTypesSelectorValue = this.filterArrayByIds(
                query.by_performance_type,
                response.data.performance_types
              );
            })
      }
    },
    getArtTypeRelations(artTypesArray) {
      this.clearOptions();
      if (artTypesArray.length) {
        const artTypesIds = artTypesArray.map(artType => artType.slug);
        axiosApi.get('/art_types/relations', { params:
          { art_type_ids: artTypesIds }
        }).then(response => {
            const newSpecialities = this.specialities;
            this.specialities = [...newSpecialities, ...response.data.specialities];

            const newGenres = this.genres;
            this.genres = [...newGenres, ...response.data.genres];

            const newPerfomanceTypes = this.perfomanceTypes;
            this.perfomanceTypes = [
              ...newPerfomanceTypes,
              ...response.data.performance_types
            ];
          })
      }
    },
    clearOptions() {
      this.specialities = [];
      this.genres = [];
      this.perfomanceTypes = [];
      this.specialitySelectorValue = [];
      this.genresSelectorValue = [];
      this.perfomanceTypesSelectorValue = [];
    },
    newBooking() {
      axios.get(`${window.location.origin}/v3/users/profile`, { headers: {
          Authorization: localStorage.getItem('token', ''),
        }
      })
      .then((response) => {
        // axios.post(`${window.location.origin}/v3/event_bookings/clear.json`, { headers: {
        //     Authorization: localStorage.getItem('token', ''),
        //   }
        // })
        // .then(res => {
          // let params = {
          //   booking: {
          //     booking_type: 'gig',
          //     booking_art_types_attributes: this.artTypeSelectorValue.map(new_art_type => {
          //       return {
          //         art_type_slug: new_art_type.slug,
          //       }
          //     })
          //   }
          // }
          // if (this.dates.length>0) {
          //   const new_dates = this.dates.split(',').map(date => {
          //     return {
          //       date: date,
          //       start_time: new Date(new Date(date).setHours(7)),
          //       end_time: new Date(new Date(date).setHours(19)),
          //     }
          //   })
          //   params.booking = { ...params.booking, booking_dates_attributes: new_dates }
          // }
          // axiosApi.put(`event_bookings/${res.data.id}`, params)
          // .then(response => {
          //   const booking_step = 'select_genre'
          //   localStorage.setItem('booking_step', booking_step)
          // })
          const fontAwesomeComponent = Vue.component('font-awesome-icon', FontAwesomeIcon)
          const newGigModalElementContainer = document.getElementById('vue-new-booking')
          Vue.prototype.$axios.defaults.baseURL = ''

          Vue.prototype.$axios.defaults.headers.common = {
            'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            Accept: 'application/json',
            'Content-Type': 'application/json; charset=utf-8'
          }
          let body = document.getElementsByTagName("body")[0]
          body.style.overflow = "hidden"
          this.newBookingModalVueInstance = new Vue({
            el: newGigModalElementContainer,
              vuetify: new Vuetify({
                theme: {
                  themes: {
                    light: {
                      primary: '#ff8141',
                      secondary: '#FFF3EC'
                    }
                  }
                }
              }),
            render: h => h(NewBooking, {}),
            components: {
              NewBooking,
              fontAwesomeComponent
            }
          })
          if (this.bookingModalEl) {
            // this.showSidebar()
            this.bookingModalEl.__x.$data.isBookingDialogOpen = true
          }
        // })
      })
      // if (this.dates.length > 0) {
      //   const new_dates = this.dates.split(',').map(date => {
      //     return {
      //       date: date,
      //       start_time: new Date(new Date(date).setHours(7)),
      //       end_time: new Date(new Date(date).setHours(19)),
      //     }
      //   })
      //   params.booking = { ...params.booking, booking_dates_attributes: new_dates }
      // }
    }
  }
};
</script>

<template>
  <div>
    <DiscoverSearch
        :location="selectedCountry.location"
        :searchLocation="searchLocation"
        @openFilters="showSidebar"
    />

    <slot name="filters" >
      <div v-if="discoverFilterItems.length > 0" class="ainfo-header mb-3 filters">
        <ul class="filter-items">
          <li
            v-for="(filterItem, index) in discoverFilterItems"
            class="p-2 pb-0">
            <a :href="updatedUrl(filterItem.url)">
              <div class="d-flex justify-content-center">
                <img :src="discoverFilterIcons[index]" style="width: 25px; height: 25px;" :alt="filterItem.name"/>
              </div>
              <span id="filterItems" class="small filter-item pt-0">{{ filterItem.name }}</span>
            </a>
          </li>
        </ul>
      </div>
    </slot>
    

    <!-- <slot name="header">
      <div class="ainfo-header pb-2">
        <div class="forms__item forms__item-100">
          <div class="forms__item-wp">
            <multiselect
              v-model="artTypeSelectorValue"
              tag-placeholder="Add this as new tag"
              placeholder="Art types"
              label="name"
              track-by="slug"
              :options.sync="artTypes"
              :multiple="true"
              :taggable="false"
              :searchable="false"
              class="margin8 discover-mobile-filter__inputs"
            ></multiselect>
            <input class="hero-search__input input">
            <button @click="newBooking()" class="btn primary btn-new-booking">Next</button>
          </div>
        </div>
      </div>
    </slot> -->

    <div class="discover">
      <slot></slot>

      <slot name="sidebar">
        <div v-if="sidebarShow" class="vm--overlay" @click="showSidebar"></div>
        <div class="discover-sidebar discover-sidebar-fixed" :class="{ show: sidebarShow }">
            <div id="instant-quote-modal" class="vm--container" x-data="{ 'isBookingDialogOpen': false }" x-show="isBookingDialogOpen" x-cloak>
              <div data-modal="share-modal" aria-expanded="true" class="vm--overlay">
                <div class="vm--top-right-slot"></div>
              </div>
              <div aria-expanded="true" role="dialog" aria-modal="true" class="vm--modal instant-quote-modal__content">
                <div class="instant-quote-modal__header">
                  <span id="instant-quote-close-btn" class="instant-quote-modal__close">x</span>
                </div>

                <div id="instant-quote-modal-body" class="instant-quote-modal__body">
                  <div id="vue-new-booking"></div>
                </div>
              </div>
            </div>
          <div class="d-flex justify-content-center discover-sidebar__mobile-instant-quotes">
            <div
                @click="showSidebar"
                class="divider w-50 mt-0 discover-sidebar__mobile-instant-quotes"
                style="background: #FF8141">
            </div>
          </div>
          <div class="discover-sidebar-wrap">
            <div class="discover-sidebar__content" :class="{ 'mt-4': sidebarShow }">
              <div class="mb-3 discover-sidebar__mobile-instant-quotes" v-if="!isArtist">
                <h5>Don't want to browse?</h5>
                <p>Get artist quotes instantly!</p>
                <button
                    class="btn primary w-100 mt-1 d-flex align-items-center justify-content-center"
                    @click="newBooking()">
                  <img :src="flashImage" class="me-2" alt="flash"/>
                  Get Instant Quotes
                </button>
              </div>

              <div
                v-if="!isArtist"
                class="divider discover-sidebar__mobile-instant-quotes">
              </div>

              <div class="filters border-bottom-0">
                <label class="label">City</label>
                <multiselect
                    v-model="citySelectorValue"
                    tag-placeholder="Add this as new tag"
                    placeholder="Enter City Name"
                    label="name"
                    track-by="slug"
                    :options="cities"
                    :multiple="true"
                    :taggable="false"
                    @input="filtersUpdated"
                    class="margin8 discover-filter_inputs">
                </multiselect>

                <label class="label">Art Types</label>
                <multiselect
                    v-model="artTypeSelectorValue"
                    tag-placeholder="Add this as new tag"
                    placeholder="Art types"
                    label="name"
                    track-by="slug"
                    :options.sync="artTypes"
                    :multiple="true"
                    :taggable="false"
                    @input="filtersUpdated"
                    class="margin8 discover-filter_inputs">
                </multiselect>

                <div v-if="specialities.length">
                  <label class="label">Specialities</label>
                  <multiselect
                      v-model="specialitySelectorValue"
                      tag-placeholder="Add this as new tag"
                      placeholder="Any"
                      class="discover-filter_inputs"
                      label="name"
                      track-by="slug"
                      :options="specialities"
                      :multiple="true"
                      :taggable="false"
                      @input="filtersUpdated">
                  </multiselect>
                </div>

                <div v-if="genres.length">
                  <label class="label">Genres</label>
                  <multiselect
                      v-model="genresSelectorValue"
                      tag-placeholder="Add this as new tag"
                      placeholder="Any"
                      class="discover-filter_inputs"
                      label="name"
                      track-by="slug"
                      :options="genres"
                      :multiple="true"
                      :taggable="false"
                      @input="filtersUpdated">
                  </multiselect>
                </div>

                <label class="label">Languages</label>
                <multiselect
                    v-model="languageSelectorValue"
                    tag-placeholder="Add this as new tag"
                    placeholder="Languages"
                    label="name"
                    track-by="slug"
                    :options="languages"
                    :multiple="true"
                    :taggable="false"
                    @input="filtersUpdated"
                    class="margin8 discover-filter_inputs">
                </multiselect>

                <label class="label">Event Types</label>
                <multiselect
                    v-model="eventTypeSelectorValue"
                    tag-placeholder="Add this as new tag"
                    placeholder="Event types"
                    label="name"
                    track-by="slug"
                    :options="eventTypes"
                    :multiple="true"
                    :taggable="false"
                    @input="filtersUpdated"
                    class="margin8 discover-filter_inputs">
                </multiselect>

                <div v-if="perfomanceTypes.length">
                  <label class="label">Performance Types</label>
                  <multiselect
                      v-model="perfomanceTypesSelectorValue"
                      tag-placeholder="Add this as new tag"
                      placeholder="Any"
                      class="discover-filter_inputs"
                      label="name"
                      track-by="slug"
                      :options="perfomanceTypes"
                      :multiple="true"
                      :taggable="false"
                      @input="filtersUpdated">
                  </multiselect>
                </div>

                <div v-if="!sidebarShow && !isArtist" class="divider"></div>

                <div v-if="!isArtist">
                  <div class="hide-follow-steps">
                    <h5>Don't want to browse?</h5>
                    <p>Get artist quotes instantly!</p>
                    <button
                        class="btn primary px-5 mb-3 mt-1 d-flex align-items-center"
                        @click="newBooking()">
                      <img :src="flashImage" class="me-2" alt="flash" />
                      Get Instant Quotes
                    </button>
                    <div class="booking-follow">
                      <div class="follow-step">
                        <div class="v-stepper">
                          <div class="circle"><span>1</span></div>
                          <div class="line"></div>
                        </div>

                        <div class="follow-content">
                          Tell us about your event.
                        </div>
                      </div>

                      <div class="follow-step">
                        <div class="v-stepper">
                          <div class="circle"><span>2</span></div>
                          <div class="line"></div>
                        </div>

                        <div class="follow-content">
                          Relevant artists will apply instantly.
                        </div>
                      </div>

                      <div class="follow-step">
                        <div class="v-stepper">
                          <div class="circle"><span>3</span></div>
                          <div class="line"></div>
                        </div>

                        <div class="follow-content">
                          Receive multiple quotes in minutes.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-block">
            <div v-if="sidebarShow" class="divider"></div>
            <div class="d-flex align-items-center">
              <button
                  class="discover-sidebar__clear btn btn-clear w-50"
                  @click="artTypeSelectorValue = []"
                  style="color: #FF8141">
                Clear all
              </button>
              <a
                  @click="updateQuery"
                  href="javascript:;"
                  class="discover-sidebar__apply btn w-50 primary ms-2">
                Apply
              </a>
            </div>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.max-budget {
  display: flex;
  &-button {
    margin-left: 8px;
  }
}

.filters {
  width: 100%;
}

.booking-follow {
  width: 260px;
}

.follow-step {
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.v-stepper {
  position: relative;
}

.follow-step .circle {
  border: 3px solid #ff8141;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  display: inline-block;
  visibility: visible;
  background-color: #ff8141;
  border-color: #ff8141;
  text-align: center;
  justify-content: center;

  span {
    font-size: 15px;
    font-weight: bold;
    color: white;
  }
}

.follow-step .line {
  top: 30px;
  left: 14px;
  height: 100%;
  position: absolute;
  border-left: 1px solid gray;
}

.follow-step:last-child .line {
  border-left: 1px solid white;
  z-index: -1;
}

.follow-content {
  margin-left: 8px;
  display: inline-block;
  font-size: 13px;
  font-weight: bold;
  margin-top: 5px;
}

.hide {
  display: none;
}

.btn-new-booking {
  position: absolute;
  right: 0;
  top: 28px;
  height: 42px;
  border: 1px solid #FF8141;
  border-radius: 2px;
}
</style>
